const data = {
	type: 'menu',
	data: {}
}

export default data
